import { _, helpers, React, ts, ui } from '_core';

import { Params } from './types';
import { nestedBarChartFormat } from '../../common/formatters/nested-bar-chart';

type ChartProps = {
  id: string;
  readOnly: boolean;
  widgetKey: string;
  portfolios: string;
  fullScreen: boolean;
  params: Params;
  title: string;
  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
};

const Chart = ({ id, readOnly, fullScreen, loadWidgetData, portfolios, title }: ChartProps) => {
  const [data, setData] = React.useState<ts.types.widgets.TableData>(null);
  const [error, setError] = React.useState<ts.types.common.ApiError>(null);

  const loadData = async () => {
    try {
      const response = await loadWidgetData({
        data: {
          file: portfolios,
        },
      });
      if (response) setData(response.data);
    } catch (err) {
      setError(err as ts.types.common.ApiError);
    }
  };

  React.useEffect(() => {
    if (portfolios) loadData();
    return () => setData(null);
  }, [portfolios]);

  const formattedData = React.useMemo(() => {
    if (_.isNil(data)) return null;
    const formattedData = nestedBarChartFormat(data, 'date');
    return {
      ...formattedData,
      data: formattedData.data.map((row) => {
        const newRow = { ...row, Turnover: row['turnover'] } as Record<string, number>;
        delete newRow['turnover'];
        return newRow;
      }),
    };
  }, [data]);

  return (
    <ui.NestedBarChart
      id={id}
      data={formattedData?.data}
      count={formattedData?.count}
      tooltipText="[bold]Turnover:[/] {valueY}"
      category="category"
      numberFormat="#.##%"
      alert={error ? { type: 'error', message: helpers.parseApiError(error) } : undefined}
      fullScreen={fullScreen}
      exportTitle={title}
      readOnly={readOnly}
    />
  );
};

export default Chart;
